import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { openInNewTab, selectLocale } from '@app/redux';

import { TabItem } from '../TabItem';
import { NavItem } from '../types';

const CommonTabs = ({
  items,
  createNavItemClickHandler,
}: {
  items: NavItem[];
  createNavItemClickHandler: (link: string) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const {
    locale: { urlPrefix },
  } = useSelector(selectLocale);
  const dispatch = useDispatch();
  const { t } = useTranslation(['Nav', 'Global']);

  const handleHelpClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const helpUrl = t('Global:viasatHelpLink');

    e.preventDefault();
    dispatch(openInNewTab(helpUrl));
  };

  return (
    <>
      {items.map((item: NavItem) => {
        const isHelpNavButton = item.label === t('Help');
        return (
          <TabItem
            key={item.label}
            {...item}
            path={`${urlPrefix}${item.path}`}
            onClick={isHelpNavButton ? handleHelpClick : createNavItemClickHandler(item.path)}
            showIcon={isHelpNavButton}
          />
        );
      })}
    </>
  );
};

export default CommonTabs;
